import { formatPrice } from "./formatPrice";

// Resolution of the subscriptions API's server-localised `messages[]`, mirroring
// asos-web-premier-subscriptions-page so both surfaces render identical copy.

// Client fallbacks applied when the API omits a Selection* message.
const SELECTION_MESSAGE_DEFAULTS = {
  SelectionDurationMessage: "{duration} months",
  SelectionMonthlyPrice: "",
  SelectionCalloutMessage: "",
  SelectionBadge: "",
};

export function getSubscriptionMessage(option, messageType) {
  const subscriptionMessage = option.messages.find(
    (message) => message.subscriptionMessageType === messageType
  );

  return (subscriptionMessage && subscriptionMessage.message) || "";
}

// Substitute the {duration}, {price} and {pricePerMonth} tokens the API uses
// in Selection* messages.
export function formatSelectionMessage(message, option, locale, currency) {
  const price = option.price.value;
  const pricePerMonth = price / option.period;

  return message
    .replaceAll("{duration}", String(option.period))
    .replaceAll("{pricePerMonth}", formatPrice(pricePerMonth, locale, currency))
    .replaceAll("{price}", formatPrice(price, locale, currency));
}

// The plan card copy: duration, monthly price, callout and badge.
// `trialDurationLabel` is a pre-localised string (e.g. "7 Days") for trials.
export function getSelectionMessages(
  option,
  locale,
  currency,
  trialDurationLabel
) {
  const resolve = (messageType) =>
    formatSelectionMessage(
      getSubscriptionMessage(option, messageType) ||
        SELECTION_MESSAGE_DEFAULTS[messageType],
      option,
      locale,
      currency
    );

  return {
    duration:
      option.trialOffer && trialDurationLabel !== undefined
        ? trialDurationLabel
        : resolve("SelectionDurationMessage"),
    monthlyPrice: resolve("SelectionMonthlyPrice"),
    callout: resolve("SelectionCalloutMessage"),
    badge: resolve("SelectionBadge"),
  };
}

// The card's price and (optional) crossed-out standard price, as text.
export function getDisplayPrice(option, locale, currency, freeLabel) {
  return {
    price: option.trialOffer
      ? freeLabel
      : formatPrice(option.price.value, locale, currency),
    standardPrice: option.price.standard
      ? formatPrice(option.price.standard.value, locale, currency)
      : undefined,
  };
}

// Whether the plan is sold as an auto-renewing (Stripe) subscription.
export function supportsAutoRenewal(option) {
  return !!(
    option.supportedInstructionTypes &&
    option.supportedInstructionTypes.includes("Recurring")
  );
}

// Whether the recurring terms & conditions variant applies.
export function hasRecurringTerms(option) {
  return supportsAutoRenewal(option) || !!option.trialOffer;
}
